export default {"src":"/_next/static/media/ic-error.55c70659.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};